import React, { useState, useEffect } from 'react';
import './OneToOneAdd.css';
import './ThankYouAdd.css'
import './adduser.css';

const ThankYouAdd = () => {
  const [formData, setFormData] = useState({
    name: '',
    date: '',
    user: '', // Initialize userId as empty string
    amount: '',
    type: 'direct', // Set default type as 'direct'
    // statusType: 'completed', // Set default statusType as 'completed'
    // moneyStatus: 'pending', // Set default moneyStatus as 'pending'
  });

  const [loading, setLoading] = useState(false); // Loading state
  const [users, setUsers] = useState([]);
  const [invitedBy, setInvitedBy] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/user', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch users');

        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          setUsers(data);
        } else {
          console.error('No users found or invalid data format');
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
    fetchProfile();

    // ✅ Set the current logged-in user's full name from localStorage
    const firstName = localStorage.getItem('firstName') || '';
    const lastName = localStorage.getItem('lastName') || '';
    const fullName = `${firstName} ${lastName}`.trim();

    setFormData(prev => ({
      ...prev,
      name: fullName,
    }));
  }, []);

  const fetchProfile = async () => {
    try {
      const profileResponse = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/my-profile`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!profileResponse.ok) throw new Error('Failed to fetch profile');

      const profileData = await profileResponse.json();
      const fullName = profileData.firstName && profileData.lastName
        ? `${profileData.firstName} ${profileData.lastName}`
        : profileData.firstName || profileData.lastName || 'Unknown User';

      setFormData((prevState) => ({
        ...prevState,
        name: fullName,
      }));
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check for required fields and display an error if any are missing
    // if (!formData.date || !formData.userId || !formData.amount || !formData.moneyStatus || !formData.type || !formData.statusType) {
    //   alert("Please fill in all required fields.");
    //   return; // Exit if any required fields are missing
    // }

    const data = {
      name: formData.name,
      date: formData.date,
      user: formData.user,
      amount: formData.amount,
      // amount: 0,
      type: formData.type,
      // statusType: formData.statusType,
      // moneyStatus: formData.moneyStatus,
    };

    try {
      const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/thankyouslip', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`, // Ensure token is in localStorage
        },
        body: JSON.stringify(data),
      });

      // Check if response is ok (status 200-299)
      if (!response.ok) {
        const text = await response.text();
        console.error('Error Response:', text);
        throw new Error(`Request failed with status ${response.status}: ${text}`);
      }

      const result = await response.json(); // Parse the JSON response

      if (result.success) {
        alert('Thank you slip added successfully');
        // Reset form data after success
        setFormData({
          date: '',
          name: formData.name,
          user: '',
          amount: '',
          type: 'direct',
          // statusType: 'completed',
          // moneyStatus: 'pending',
        });
      } else {
        alert('Error: ' + result.message); // Show server error message
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the form. Please try again later.');
    }
  };

  const formatLocalDate = (date) => {
    if (!date) return '';

    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Adjust for timezone offset
    return d.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
  };


  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerOne">
          <h2 className='AddOneToOne'>Add Thank You Slip</h2>
          <form id="userForm" onSubmit={handleSubmit}>
            <div className="form-group1">
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Date"
                value={formData.date ? formatLocalDate(formData.date) : ''}
                onChange={handleChange}
                required
                max={new Date().toISOString().split("T")[0]} // Restrict future dates
              />
            </div>
            
            <div className="form-group1">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                value={formData.name}
                style={{ backgroundColor: '#e9ebf7' }}
                readOnly
                required
              />
            </div>

            <div>
              <select
                id="user"
                name="user" // Correct name for userId
                className="form-group11"
                value={formData.user} // Bind value to userId
                onChange={handleChange}
                required
              >
                <option value="">Select User</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  users.map((user) => {
                    const userName = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : 'Unknown';
                    return (
                      <option key={user._id} value={user._id}>
                        {userName}
                      </option>
                    );
                  })
                )}
              </select>
            </div>

            <div className="form-group1">
              <input
                type="amount"
                id="amount"
                name="amount"
                value={formData.amount} // Bind the value to formData
                onChange={handleChange}
                placeholder="Amount"
                required
              />
            </div>


            <div className="radio-sectionn">
              <label className="section-labell">Type :-</label>
              <div className="radio-optionss">
                <label>
                  <input
                    type="radio"
                    name="type"
                    value="direct"
                    checked={formData.type === 'direct'}
                    onChange={handleChange}
                  />
                  Direct (HLABC Member)
                </label>
                <label>
                  <input
                    type="radio"
                    name="type"
                    value="indirect"
                    checked={formData.type === 'indirect'}
                    onChange={handleChange}
                  />
                  Indirect (From member reference)
                </label>
              </div>
            </div>




            <button type="submit" className="btnOne">
              Add Thank You Slip
            </button>

          </form>
        </div>
      </main>
    </div>
  );
};

export default ThankYouAdd;
